<app-pub-header></app-pub-header>
<router-outlet></router-outlet>
<app-pub-footer></app-pub-footer>

<ul id="tlyPageGuidePUBLIC" data-tourtitle="Home de FACeB2B" class="d-none">
  <!--HOME-->

  <li class="tlypageguide_left" data-tourtarget=".welcome_element_to_target">
    <p>
      FACeB2B es la plataforma de distribución de facturas electrónicas para los operadores económicos y particulares que habilita la remisión de facturas entre subcontratistas y contratistas de los contratos del Sector Público. FACeB2B inerconecta plataformas privadas de distribución de facturas, pudiendo ser utilizada igualmente para relaciones B2B no enmarcadas en la contratación pública.
    </p>
  </li>
  <li class="tlypageguide_left" data-tourtarget=".buscador_element_to_target">
    <p>
      Usando varios criterios de búsqueda se podrá conocer la información de los clientes que ya están habilitados para recibir facturas a través de FACeB2B.
    </p>
  </li>
  <li class="tlypageguide_right" data-tourtarget=".menuListado_element_to_target">
    <p>
      En este listado podrá encontrar las empresas que ofrecen sus servicios como Empresas de Servicios de Facturación (ESF) a terceros. En la descripción encontrará toda la información de sus servicios.
    </p>
  </li>
  <li class="tlypageguide_top" data-tourtarget=".zonaCLIENTE_element_to_target">
    <div>
      <p>Para poder trabajar como Cliente en FACeB2B hay que tener un certificado electrónico válido y haberse dado de alta previamente en DIRe. En FACeB2B como Cliente, puede autorizar a una Empresa de Servicios de Facturación (ESF) a gestionar las facturas de sus unidades receptoras.</p>
      <p>La primera vez en FACeB2B tendrá que darse de alta. El alta se firmará con el miniapplet de @firma. <a href="http://firmaelectronica.gob.es/Home/Descargas.html" target="_blank" class="apunteDescacado">Descárguelo aquí</a> </p>
    </div>
  </li>
  <li class="tlypageguide_top" data-tourtarget=".zonaESF_element_to_target">
    <div>
        <p>Para poder trabajar como Empresa de Servicio de Facturación (ESF) en FACeB2B debe disponer de un certificado electrónico válido y haberse dado de alta previamente en DIRe. </p>
        <p>En FACeB2B como ESF, puede gestionar las facturas de las unidades receptoras de sus clientes, o las suyas propias, a través de su Plataformas de Facturación.</p>
        <p>La primera vez en FACeB2B tendrá que darse de alta. El alta se firmará con el miniapplet de @firma. <a href="http://firmaelectronica.gob.es/Home/Descargas.html" target="_blank">Descárguelo aquí</a></p>
    </div>
  </li>

</ul>




<div class="tlyPageGuideWelcome">
    <p><img src="assets/images/logoB2B-white.png" alt="logo FACeB2B"></p>
    <p>Bienvenido a FACeB2B ¿quiere conocer más acerca de esta plataforma?</p>
    <p><button class="tlypageguide_start">Ver Tutorial</button> <button class="tlypageguide_dismiss negativo">Omitir tutorial</button></p>
		<hr />
    <p class="notaPie">Para volver a acceder a este resumen puede hacerlo pulsaldo <b>Guía de uso</b> en el menu del pie de página</p>
</div>



// WEBPACK FOOTER //
// ./src/app/app-public/public.component.html